exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._36fSLIiJPo5t-VtsggK1rd{display:-ms-flexbox;display:flex;display:-webkit-box}.Qm-QPxbkqj7HQftdAqzj0{font-weight:600;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;width:150px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}html[dir] .Qm-QPxbkqj7HQftdAqzj0{padding-top:7px}", ""]);

// exports
exports.locals = {
	"contentHeaderContainer": "_36fSLIiJPo5t-VtsggK1rd",
	"contentName": "Qm-QPxbkqj7HQftdAqzj0"
};